import { useDispatch, useSelector } from 'react-redux';
import { setLanguageCode } from 'lib/actions/languages';
import { getLanguage } from 'lib/selectors';
import useLocalStorage from 'utils/hooks/useLocalStorage';

export default function useSelectLanguage() {
    const dispatch = useDispatch();
    const language = useSelector(getLanguage);
    const [, setLangInStorage] = useLocalStorage('languageCode', null);

    const handleChange = (_, value) => {
        setLangInStorage(value);

        dispatch(setLanguageCode(value));
    };

    return [language, handleChange];
}
